module.exports = __webpack_public_path__ + "img/offer_icon.0b8ce800.svg";